import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import {
    FAILURE_CUSTOMER_MESSAGES,
    REQUEST_CUSTOMER_MESSAGES,
    SUCCESS_CUSTOMER_MESSAGES,
    SUCCESS_CUSTOMER_MESSAGE_READ,
} from './actions';

/* Customer Messages */
export function customerMessagesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_MESSAGES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_MESSAGES:
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        case FAILURE_CUSTOMER_MESSAGES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        case SUCCESS_CUSTOMER_MESSAGE_READ:
            return _.assign({}, state, {
                items: (state.items ?? []).map((item: any) =>
                    item.id === action.messageId && item.readAt == null
                        ? { ...item, readAt: new Date().toISOString() }
                        : item
                ),
            });
        default:
            return state;
    }
}
